import { useEffect, useMemo, useState } from "react";

import { UIView, useCurrentStateAndParams } from "@uirouter/react";
import { ErrorBoundary } from "react-error-boundary";
import { useDispatch, useSelector } from "react-redux";

import { showNoAccessModal } from "app/actions/segmentsModuleActions";
import { ErrorFallback } from "app/components/error-boundary-no-data/ErrorBoundaryEmptyState";
import { useAutoScrollTop } from "app/custom-hooks/useAutoScrollTop";
import { loadCustomSegmentsMetadata } from "app/pages/segments/config/segmentsConfigHelpers";
import DeleteSegmentsGroupConfirmationModal from "app/pages/segments/modals/DeleteSegmentsGroupConfirmationModal";
import { NoAccessSegmentModal } from "app/pages/segments/modals/NoAccessSegmentModal";
import SegmentGroupModal from "app/pages/segments/modals/SegmentGroupModal";
import { SegmentsPageLoader } from "app/pages/segments/segmentsPageLoader";
import { SegmentsHomepageWrapper } from "app/pages/segments/styleComponents";
import { SegmentsUtils } from "app/services/segments/SegmentsUtils";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const SegmentsRootContainer = () => {
    const { state: currentState, params } = useCurrentStateAndParams();
    const dispatch = useDispatch();

    const { segmentsLoading, customSegmentsMeta, shouldShowNoAccessModal } = useSelector((state) => {
        const {
            segmentsModule: { segmentsLoading, customSegmentsMeta, shouldShowNoAccessModal },
        } = state;
        return {
            segmentsLoading,
            customSegmentsMeta,
            shouldShowNoAccessModal,
        };
    });
    const [segmentsModuleIsReady, setSegmentsModuleIsReady] = useState(false);

    const { id: segmentId, mode } = params;

    const accessibleSegmentsArray = customSegmentsMeta?.AccountSegments && [...customSegmentsMeta?.AccountSegments];

    const isSegmentHasAccess = useMemo(() => {
        const segment = SegmentsUtils.getSegmentById(
            {
                segments: accessibleSegmentsArray,
            },
            segmentId,
        );
        return Boolean(segment);
    }, [accessibleSegmentsArray, segmentId]);

    const ref = useAutoScrollTop();
    useEffect(() => {
        loadCustomSegmentsMetadata();
    }, []);
    useEffect(() => {
        setSegmentsModuleIsReady(!segmentsLoading && !!customSegmentsMeta);
    }, [segmentsLoading]);

    const onCloseModal = (shouldShow) => {
        dispatch(showNoAccessModal(shouldShow));
    };
    //in case we are in one of segments' pages(which have SegmentId as a param) but we don't have access to it
    if (segmentId && mode === "single" && !isSegmentHasAccess && !shouldShowNoAccessModal && customSegmentsMeta) {
        dispatch(showNoAccessModal(true));
        proNavigator.go("digitalsuite_segments-homepage");
        return null;
    }
    return (
        <ErrorBoundary
            FallbackComponent={ErrorFallback}
            resetKeys={[currentState, params]}
        >
            {segmentsModuleIsReady ? (
                <SegmentsHomepageWrapper
                    ref={ref}
                    className={"sw-layout-module fadeIn"}
                >
                    <UIView />
                </SegmentsHomepageWrapper>
            ) : (
                <SegmentsPageLoader />
            )}
            <NoAccessSegmentModal
                isOpen={shouldShowNoAccessModal}
                onCloseModal={onCloseModal}
            />
            <SegmentGroupModal />
            <DeleteSegmentsGroupConfirmationModal />
        </ErrorBoundary>
    );
};
